import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Want to get the most out of your customer data?`,
  description: `Join the 25,000+ customers on the Segment platform today.`,
}

const buttonData = {
  text: `Request a demo`,
  href: `https://segment.com/demo/?utm_source=report&utm_medium=referral&utm_campaign=all_cnt_2024-06-13-cdp-report-2024_&utm_content=ebook`,
}

const RequestDemo = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <StyledSection variant="centered">
        <Section.Copy>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
          <StyledDescription variant="pLarge" tag="p">
            {copy.description}
          </StyledDescription>
          <ButtonWrapper>
            <Button
              variant="filled"
              size="large"
              color="primary"
              href={getAbsoluteUrl(buttonData.href, pageConfig)}
              key={buttonData.text}
            >
              {buttonData.text}
            </Button>
          </ButtonWrapper>
        </Section.Copy>
      </StyledSection>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.mint[10]};
`

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
  }
`

const StyledDescription = styled(CopyText.Description)`
  margin: 0;
`

const ButtonWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
  gap: 16px;
`

export default RequestDemo
